import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import React from 'react';

import { LoadingButton } from './LoadingButton';

type ConfirmDialogProps = {
    open: boolean;
    title: string;
    confirmLabel: string;
    onConfirm: () => void;
    onClose: () => void;
    /** True while the confirmed action runs: both buttons lock and the confirm one spins. */
    loading?: boolean;
    children: React.ReactNode;
};

export function ConfirmDialog({
    open,
    title,
    confirmLabel,
    onConfirm,
    onClose,
    loading = false,
    children,
}: ConfirmDialogProps) {
    return (
        <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit" disabled={loading}>
                    Cancel
                </Button>
                <LoadingButton onClick={onConfirm} color="error" variant="contained" loading={loading}>
                    {confirmLabel}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
